import { Form } from 'antd';
import { Formik, FormikConfig, FormikProps } from 'formik';
import TaskName from './TaskName';
import ApplyScope from './ApplyScope';
import InSiteRemindEnable from './InSiteRemindEnable';
import { FV, storeScopes2applyScope } from './share';
import { ReactNode } from 'react';

export interface TaskFormProps extends Util.PartialPartial<FormikConfig<FV>, 'initialValues'> {
  children: (form: ReactNode, props: FormikProps<FV>) => ReactNode;
}

const defaultInitialValues: FV = {
  taskName: '',
  applyScope: storeScopes2applyScope([]),
  inSiteRemindEnable: false,
};

function TaskForm(props: TaskFormProps) {
  const { children, initialValues = defaultInitialValues, ...otherProps } = props;

  return (
    <Formik enableReinitialize initialValues={initialValues} {...otherProps}>
      {(props) => {
        const form = (
          <Form>
            <TaskName />
            <ApplyScope />
            <InSiteRemindEnable />
          </Form>
        );

        return children(form, props);
      }}
    </Formik>
  );
}

export default TaskForm;
